import { V } from '@angular/cdk/scrolling-module.d-aa3aedaa';
import { Component, Inject, ViewContainerRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NZ_MODAL_DATA, NzModalModule, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { CreateOrganizationModel } from 'src/app/shared/model/create-organizaion.model';
import { CustomNotificationService } from 'src/app/shared/services/custom.notification.service';
import { OrganizationService } from 'src/app/shared/services/organization.service';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-create-organization',
  imports: [ NzIconModule,
      NzFormModule,
      NzCheckboxModule,
      NzButtonModule,
      NzCardModule,
      SharedModule,
      NzInputModule,
      NzModalModule],
  templateUrl: './create-organization.component.html',
  styleUrl: './create-organization.component.scss',
  standalone: true
})
export class CreateOrganizationComponent {
  organizationForm: UntypedFormGroup;
  newUser:CreateOrganizationModel = { name: '', email:'',address:'',phone:'',city:'',country_id:'',mobile:''};
  allAccess: any[] = []
  isEdit: boolean = false;
  isLoading: boolean = false;
  organization: any[] = [];
  roles : any[] = [];
  constructor(
  private readonly fb: UntypedFormBuilder,
  private  readonly notification: CustomNotificationService,
  private readonly modalRef:NzModalRef<CreateOrganizationComponent>,
  private readonly organizationService:OrganizationService,
  private readonly router:Router,
  private readonly modalService: NzModalService,
  private readonly viewContainerRef: ViewContainerRef,
  @Inject(NZ_MODAL_DATA) public data:any) {
    this.isEdit = this.data.isEdit;
  this.organizationForm = this.fb.group({
    name: [this.newUser.name, [Validators.required]],
    // i want that email is optional but if it is provided it should be valid email
    email: [this.newUser.email, [Validators.email]],
    phone: [this.newUser.phone, []],
    mobile: [this.newUser.mobile, []],
    address: [this.newUser.address,[]],
    city: [this.newUser.city, []],
    country: [this.newUser.country_id, [Validators.maxLength(3)]],
  });
 }

  listOfSelectedRoles = [];


  ngOnInit(): void {
    
    }
  
  

  submitForm(): void {
    if (this.organizationForm.valid) {
      const org :CreateOrganizationModel= {
        name: this.organizationForm.controls.name.value,
        email: this.organizationForm.controls.email.value,
        phone: this.organizationForm.controls.phone.value,
        mobile: this.organizationForm.controls.mobile.value,
        address: this.organizationForm.controls.address.value,
        city: this.organizationForm.controls.city.value,
        country_id: this.organizationForm.controls.country.value,
      }

        this.isLoading = true;
        this.organizationService.createOrganization(org).then((res:any) => {
        this.modalRef.close({success: true});
        this.notification.show('success','Success','Organization created successfully' ,'topRight');
        this.isLoading = false;
        this.router.navigate(["/login"]);
        }, (error) => {
          this.notification.show('error', 'Error', error.error.error.message,'topRight');
          this.isLoading = false;
        })
    } else {
      Object.values(this.organizationForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }

  }
  
  handleOk(): void {
    console.log('Button ok clicked!');
  }

  handleCancel(): void {
    this.modalRef.close();
  }

  disableSave() {
    return !(
      this.organizationForm.controls.name.value && 
      this.organizationForm.controls.name.valid
    );
  }

  createOrganization = () => {
      this.modalService.create({
      nzTitle: 'Create Organization',
      nzContent: CreateOrganizationComponent,
      nzData: {isEdit: false},
      nzStyle: { height: '90%'},
      nzWrapClassName: 'ant-modal-body-without-padding',
      nzViewContainerRef: this.viewContainerRef,
      nzFooter: null,
    });
  }
}
